/* eslint-disable */
import { useMemo } from "react";
import { ICalendarSelectorGroup } from "../types";

export function useSelectAll(
  groups: ICalendarSelectorGroup[],
  updateGroups: (groups: ICalendarSelectorGroup[]) => void,
) {
  return useMemo(() => {
    const result: ICalendarSelectorGroup[] = [];
    for (const group of groups) {
      const nextGroup = { ...group, items: group.items.map((x) => ({ ...x, active: !x.disabled && !x.virtual })) };
      result.push(nextGroup);
    }
    if (!groups.some(g => g.items.some(i => !i.active && !i.disabled && !i.virtual))) {
      return null;
    }
    return () => updateGroups(result);
  }, [groups]);
}
